module.exports = __webpack_public_path__ + "static/img/yytx11.c93e428.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx11.png
// module id = 883
// module chunks = 0